import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

import { RegisterVerificationTokenData } from '@core/models/register';
import { RegisterService } from '@core/services/register.service';

export const registerVerificationTokenResolver: ResolveFn<
  RegisterVerificationTokenData | null
> = () => {
  const registerService = inject(RegisterService);
  const router = inject(Router);
  const jwtHelper = new JwtHelperService();

  const isValidToken = registerService.validateRegisterVerificationToken();
  if (!isValidToken) {
    router.navigate(['/register']);
    return null;
  }

  const token = registerService.getRegisterVerificationToken();

  if (!token) {
    router.navigate(['/register']);
    return null;
  }

  const payload = jwtHelper.decodeToken(token);

  if (!payload) {
    registerService.removeRegisterVerificationToken();
    router.navigate(['/register']);
    return null;
  }

  return { token, payload };
};
